var $67e9091dbf37d4eb$exports = {};
$67e9091dbf37d4eb$exports = {
  "calendar": `\u{B2EC}\u{B825}`,
  "day": `\u{C77C}`,
  "dayPeriod": `\u{C624}\u{C804}/\u{C624}\u{D6C4}`,
  "endDate": `\u{C885}\u{B8CC}\u{C77C}`,
  "era": `\u{C5F0}\u{D638}`,
  "hour": `\u{C2DC}`,
  "minute": `\u{BD84}`,
  "month": `\u{C6D4}`,
  "second": `\u{CD08}`,
  "selectedDateDescription": args => `\u{C120}\u{D0DD} \u{C77C}\u{C790}: ${args.date}`,
  "selectedRangeDescription": args => `\u{C120}\u{D0DD} \u{BC94}\u{C704}: ${args.startDate} ~ ${args.endDate}`,
  "selectedTimeDescription": args => `\u{C120}\u{D0DD} \u{C2DC}\u{AC04}: ${args.time}`,
  "startDate": `\u{C2DC}\u{C791}\u{C77C}`,
  "timeZoneName": `\u{C2DC}\u{AC04}\u{B300}`,
  "weekday": `\u{C694}\u{C77C}`,
  "year": `\u{B144}`
};
export { $67e9091dbf37d4eb$exports as default };